// One-off components
import $ from 'jquery';
import sliders from './sliders/index';
import Typed from './typed-js/typed.js';
import './form/donate-form.js';
import './section/section-accordion.js';
import './search-bar/index.js'

export const headerDropdownComponent = {
  dropdown: $(document).ready(function ($) {
    let headerDropdownButton = document.getElementById('button-header-dropdown');
    let headerDropdownSpan = headerDropdownButton.querySelector('span');
    let headerDropdown = document.getElementById('header-dropdown');

    if (headerDropdownButton && headerDropdown) {
      headerDropdownButton.addEventListener('click', handleDropdownClick);
    }

    function handleDropdownClick (e) {
      if (headerDropdown.classList.contains('active')) {
        headerDropdown.classList.remove('active');
        document.querySelector( '.header-logo__bottom' ).classList.remove('header-logo__bottom--active');
      } else {
        headerDropdown.classList.add('active');
        headerDropdown.style.zIndex = '1000';
        headerDropdownSpan.classList.remove('fa');
        headerDropdownSpan.classList.remove('fa-bars');
        headerDropdownSpan.classList.remove('text--primary');
        headerDropdownSpan.classList.add('fas');
        headerDropdownSpan.classList.add('fa-times');
        headerDropdownSpan.classList.add('text--black');
        document.querySelector( '.header-logo__bottom' ).classList.add('header-logo__bottom--active');
        setTimeout(() => {
          headerDropdown.clickListener = window.addEventListener('click', checkClick);
        }, 200);
      }

    }

    function checkClick (e) {
      if ($(headerDropdown).find(e.target).length === 0 && $(headerDropdown) !== $(e.target)) {
        headerDropdown.classList.remove('active');
        window.removeEventListener('click', checkClick);
        headerDropdownSpan.classList.remove('fas');
        headerDropdownSpan.classList.remove('fa-times');
        headerDropdownSpan.classList.remove('text--black');
        headerDropdownSpan.classList.add('fa');
        headerDropdownSpan.classList.add('fa-bars');
        headerDropdownSpan.classList.add('text--primary');
      }
    }
  })
}

export const Sliders = sliders;
